<script>
    import { fly } from "svelte/transition";
    import { Accordion, AccordionItem } from "../index";
    const articles = [
        {
            title: "第一项",
            content:
                "Web Components 是一套不同的技术，允许您创建可重用的定制元素（它们的功能封装在您的代码之外）并且在您的web应用中使用它们。",
        },
        {
            title: "第二项",
            content:
                "Web Components 是一套不同的技术，允许您创建可重用的定制元素（它们的功能封装在您的代码之外）并且在您的web应用中使用它们。Web Components 是一套不同的技术，允许您创建可重用的定制元素（它们的功能封装在您的代码之外）并且在您的web应用中使用它们。Web Components 是一套不同的技术，允许您创建可重用的定制元素（它们的功能封装在您的代码之外）并且在您的web应用中使用它们。Web Components 是一套不同的技术，允许您创建可重用的定制元素（它们的功能封装在您的代码之外）并且在您的web应用中使用它们。",
        },
        {
            title: "第三项",
            content:
                "Web Components 是一套不同的技术，允许您创建可重用的定制元素（它们的功能封装在您的代码之外）并且在您的web应用中使用它们。",
        },
    ];
    let activeKey = 1;
</script>

<div class="example" transition:fly={{ x: 200 }}>
    <h4 class="example-title">基础用法</h4>
    <div class="example-body nopadding">
        <Accordion>
            {#each articles as { title, content }, i}
                <AccordionItem {title} active={activeKey === i}>
                    {content}
                </AccordionItem>
            {/each}
        </Accordion>
    </div>
    <h4 class="example-title">非手风琴模式</h4>
    <div class="example-body nopadding">
        <Accordion accordion={false}>
            {#each articles as { title, content }, i}
                <AccordionItem {title} active={activeKey === i}>
                    {content}
                </AccordionItem>
            {/each}
        </Accordion>
    </div>
    
</div>

<style lang="less">
    @import "./example.less";
    .nopadding {
        padding: 0;
    }
</style>
